module.exports = __webpack_public_path__ + "static/media/how-to-bid.a8cde563.svg";